import Vue from 'vue'
import axios from 'axios'
import { once } from 'ramda'
import { getReports } from '~/api/reports'
import { router } from '~/router'

export const useReports = once(() => {
	/** @type {{ reports: Report[], loading: boolean }} */
	const state = Vue.observable({
		reports: [],
		loading: false,
	})

	let source

	const mutate = async () => {
		state.loading = true

		source?.abort()
		source = new AbortController()

		return getReports(router.currentRoute.query).then((response) => {
			state.reports = response.data.items
			state.loading = false

			return state.reports
		})
	}

	return {
		get data() {
			return state.reports
		},
		get isValidating() {
			return state.loading
		},
		mutate
	}
})
